import { render, staticRenderFns } from "./doubleArea.vue?vue&type=template&id=32f804ff&scoped=true&"
import script from "./doubleArea.vue?vue&type=script&lang=js&"
export * from "./doubleArea.vue?vue&type=script&lang=js&"
import style0 from "./doubleArea.vue?vue&type=style&index=0&id=32f804ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f804ff",
  null
  
)

export default component.exports